import React from 'react'
import img from '../../../../app/pages/property/submit-property.png'
import { Link, useParams } from 'react-router-dom'

const RentPaymentSuccessPage = () => {
    const {id} = useParams()
    console.log("OOOOO", id)
    return (
        <div className='card-body card min-vh-95 p-0 pb-5'>
            {/* Begin:: Vitta logo */}
            <img
                alt='Logo'
                src='/media/logos/favicon2.jpg'
                className='h-100px mx-auto d-block mt-2'
            ></img>
            {/* End:: Vitta logo */}
            <div data-kt-stepper-element='content'>
                <div className='w-100 text-center'>
                    {/* begin::Illustration */}
                    <div className='text-center'>
                        <img src={img} alt='img' className='mw-100 mh-200px' />
                    </div>
                    {/* end::Illustration */}
                    {/* begin::Heading */}
                    <h1 className='fw-bold text-dark mb-3'>Success!</h1>
                    {/* end::Heading */}
                    {/* begin::Description */}
                    <div className='text-muted fw-semibold fs-3'>
                        Rent paid successfully
                    </div>
                    {/* end::Description */}
                    <Link to={`/rented-properties/${id}`} className='btn btn-sm fw-bold btn-primary my-4'>Back</Link>
                </div>
            </div>
        </div>
    )
}

export default RentPaymentSuccessPage